module.exports = __webpack_public_path__ + "static/media/asses_cadastral.2ed10ec7.svg";